(() => {
  'use strict';

  const root = (window.MovingRoom && window.MovingRoom.root) || '/';
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char]);

  function initCatalogViews(scope = document) {
    $$('[data-r31-view-root]', scope).forEach(rootNode => {
      if (rootNode.dataset.r31ViewReady) return;
      rootNode.dataset.r31ViewReady = 'true';
      $$('[data-r31-view]', rootNode).forEach(button => button.addEventListener('click', () => {
        const view = button.dataset.r31View || 'grid';
        rootNode.dataset.catalogView = view;
        $$('[data-r31-view]', rootNode).forEach(item => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }));
    });
  }

  async function addQuickObject(form) {
    const button = $('button[type="submit"]', form);
    const label = $('[data-r31-quick-label]', form);
    if (!button || button.disabled) return;
    button.disabled = true;
    if (label) label.textContent = 'ADDING…';
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.description || 'This object could not be added.');
      if (label) label.textContent = 'ADDED ✓';
      const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        $$('[data-cart-count]').forEach(node => { node.textContent = cart.item_count; });
      }
      setTimeout(() => $('[data-cart-open]')?.click(), 180);
    } catch (error) {
      if (label) label.textContent = 'TRY AGAIN';
      const toast = $('[data-mr-toast]');
      if (toast) {
        toast.textContent = error.message;
        toast.classList.add('is-visible');
        setTimeout(() => toast.classList.remove('is-visible'), 2600);
      }
    } finally {
      setTimeout(() => {
        button.disabled = false;
        if (label && label.textContent !== 'TRY AGAIN') label.textContent = '+ BAG';
      }, 1200);
    }
  }

  function initQuickAdd(scope = document) {
    $$('[data-r31-quick-add]', scope).forEach(form => {
      if (form.dataset.r31Ready) return;
      form.dataset.r31Ready = 'true';
      form.addEventListener('submit', event => {
        if (!$('[data-cart-drawer]')) return;
        event.preventDefault();
        addQuickObject(form);
      });
    });
  }

  function renderPredictive(products, destination) {
    if (!destination) return;
    if (!products.length) {
      destination.innerHTML = '<p class="r31-predictive-empty">NO OBJECT SIGNAL FOUND. PRESS ENTER FOR THE FULL SCAN.</p>';
      return;
    }
    destination.innerHTML = `<div class="r31-predictive-list">${products.map((product, index) => {
      const image = product.image || product.featured_image;
      const sizedImage = image ? `${image}${String(image).includes('?') ? '&' : '?'}width=180` : '';
      return `<a href="${escapeHtml(product.url)}"><span>${String(index + 1).padStart(2, '0')}</span>${sizedImage ? `<img src="${escapeHtml(sizedImage)}" width="90" height="90" alt="">` : '<i></i>'}<div><small>${escapeHtml(product.type || product.vendor || 'MOVEMENT OBJECT')}</small><strong>${escapeHtml(product.title)}</strong><b>${escapeHtml(product.price || '')}</b></div><em>↗</em></a>`;
    }).join('')}</div>`;
  }

  function initPredictiveSearch(scope = document) {
    $$('[data-r31-predictive-input]', scope).forEach(input => {
      if (input.dataset.r31Ready) return;
      input.dataset.r31Ready = 'true';
      const results = $('[data-r31-predictive-results]', input.closest('[data-search-panel]') || document);
      let timer = 0;
      let controller;
      input.addEventListener('input', () => {
        window.clearTimeout(timer);
        controller?.abort();
        const query = input.value.trim();
        if (query.length < 2) {
          if (results) results.innerHTML = '';
          return;
        }
        timer = window.setTimeout(async () => {
          controller = new AbortController();
          try {
            const endpoint = `${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last`;
            const response = await fetch(endpoint, { headers: { Accept: 'application/json' }, signal: controller.signal });
            if (!response.ok) throw new Error('Predictive search unavailable');
            const data = await response.json();
            renderPredictive(data?.resources?.results?.products || [], results);
          } catch (error) {
            if (error.name !== 'AbortError' && results) results.innerHTML = '';
          }
        }, 220);
      });
    });
  }

  function slugify(value, index) {
    const slug = value.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    return slug || `record-${index + 1}`;
  }

  function initDocumentIndex(scope = document) {
    $$('[data-r31-document]', scope).forEach(documentNode => {
      if (documentNode.dataset.r31TocReady) return;
      documentNode.dataset.r31TocReady = 'true';
      const source = $('[data-r31-toc-source]', documentNode);
      const target = $('[data-r31-toc]', documentNode);
      if (!source || !target) return;
      const headings = $$('h2,h3', source);
      if (!headings.length) {
        target.innerHTML = '<p>COMPLETE RECORD / NO SUBSECTIONS</p>';
        return;
      }
      const used = new Set();
      headings.forEach((heading, index) => {
        let id = heading.id || slugify(heading.textContent, index);
        while (used.has(id) || (document.getElementById(id) && document.getElementById(id) !== heading)) id = `${id}-${index + 1}`;
        used.add(id);
        heading.id = id;
      });
      target.innerHTML = headings.map((heading, index) => `<a href="#${escapeHtml(heading.id)}" data-r31-toc-link="${escapeHtml(heading.id)}"><span>${String(index + 1).padStart(2, '0')}</span>${escapeHtml(heading.textContent)}</a>`).join('');
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          $$('[data-r31-toc-link]', target).forEach(link => link.classList.toggle('is-current', link.dataset.r31TocLink === entry.target.id));
        }), { rootMargin: '-20% 0px -70% 0px' });
        headings.forEach(heading => observer.observe(heading));
      }
    });
  }

  function initPrint(scope = document) {
    $$('[data-r31-print]', scope).forEach(button => {
      if (button.dataset.r31Ready) return;
      button.dataset.r31Ready = 'true';
      button.addEventListener('click', () => window.print());
    });
  }

  function initContactPrefill(scope = document) {
    $$('[data-r31-contact]', scope).forEach(node => {
      if (node.dataset.r31Ready) return;
      node.dataset.r31Ready = 'true';
      const content = $('[data-contact-content]', node);
      if (content) {
        // Normalize the imported document locally; never change the saved page HTML.
        $$('h1 br,h2 br,h3 br,h4 br,h5 br,h6 br', content).forEach(br => br.replaceWith(document.createTextNode(' ')));
        const normalize = text => text.trim().replace(/\s+/g, ' ').toLowerCase();
        const first = content.querySelector('h1,h2,h3');
        if (first && ['contact', 'contact us', 'contact information', normalize(content.dataset.sourceTitle || '')].includes(normalize(first.textContent))) first.hidden = true;
      }
      const params = new URLSearchParams(window.location.search);
      const productHandle = params.get('product');
      const orderNumber = params.get('order');
      const product = $('[data-r31-contact-product]', node);
      const subject = $('[data-r31-contact-subject]', node);
      const routeButtons = $$('[data-r31-contact-route]', node);
      const selectRoute = (value, moveToForm = false) => {
        if (!subject || !$$('option', subject).some(option => option.value === value || option.textContent.trim() === value)) return;
        subject.value = value;
        routeButtons.forEach(button => {
          const active = button.dataset.r31ContactRoute === value;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (moveToForm) {
          const formPanel = subject.closest('.r31-contact__form');
          formPanel?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          window.setTimeout(() => subject.focus({ preventScroll: true }), 320);
        }
      };
      routeButtons.forEach(button => button.addEventListener('click', () => selectRoute(button.dataset.r31ContactRoute, true)));
      subject?.addEventListener('change', () => selectRoute(subject.value));
      if (productHandle && product && $$('option', product).some(option => option.value === productHandle)) {
        product.value = productHandle;
        selectRoute('Product fit or function');
      }
      const space = params.get('space');
      if (space) {
        const body = $('[name="contact[body]"]', node);
        if (body && !body.value.trim()) body.value = 'Please help me check this setup.\n' + space.slice(0, 1200);
        selectRoute('Product fit or function');
      }
      if (orderNumber) {
        const order = $('[name="contact[order_number]"]', node);
        if (order) order.value = orderNumber;
        selectRoute('Order status');
      }
      if (subject?.value) selectRoute(subject.value);
      const success = $('[data-r31-form-success]', node);
      if (success) window.requestAnimationFrame(() => success.focus());
    });
  }

  function updateProvince(country) {
    const form = country.closest('form');
    const province = $('[data-r31-province]', form || document);
    if (!province) return;
    const option = country.options[country.selectedIndex];
    let provinces = [];
    try { provinces = JSON.parse(option?.dataset?.provinces || '[]'); } catch (_) { provinces = []; }
    const selected = province.dataset.default || '';
    province.innerHTML = provinces.map(entry => `<option value="${escapeHtml(entry[0])}"${entry[0] === selected ? ' selected' : ''}>${escapeHtml(entry[1])}</option>`).join('');
    province.closest('label')?.toggleAttribute('hidden', provinces.length === 0);
    province.dataset.default = '';
  }

  function initAddressForms(scope = document) {
    $$('[data-r31-country]', scope).forEach(country => {
      if (country.dataset.r31Ready) return;
      country.dataset.r31Ready = 'true';
      if (country.dataset.default) country.value = country.dataset.default;
      updateProvince(country);
      country.addEventListener('change', () => updateProvince(country));
    });
  }

  function initRecover(scope = document) {
    $$('[data-r31-recover-open]', scope).forEach(link => {
      if (link.dataset.r31Ready) return;
      link.dataset.r31Ready = 'true';
      link.addEventListener('click', () => setTimeout(() => $('#RecoverAccess input[type="email"]')?.focus(), 120));
    });
  }

  function init(scope = document) {
    initCatalogViews(scope);
    initQuickAdd(scope);
    initPredictiveSearch(scope);
    initDocumentIndex(scope);
    initPrint(scope);
    initContactPrefill(scope);
    initAddressForms(scope);
    initRecover(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('room:content:loaded', event => init(event.target));
})();
